export default __webpack_public_path__ + "static/media/jdn.73a380e5.png";